import {axiosInstance} from "../services/axiosInstance";

export const rating = async (rate, user_id, product_id) => {
  const { data } = await axiosInstance.get(`/ratings?rate=${rate}&user_id=${user_id}&product_id=${product_id}`);
  return data;
};
